'use strict';

var EditSiteVpn = require('actionGroups/editSiteVpn/EditSiteVpn');
var FormView = require('actionGroups/editSiteVpn/EditSiteVpnView');

module.exports = {
  Model: EditSiteVpn,
  GroupView: FormView,
};
